import { ApyFilterEnum } from "~/types/apy";
import type { IOption } from "~/types/option";

export const APY_TOOLTIP_TEXT =
  "APY is the annualized return based on current pricing and time to resolution.";

export const labelByApyFilterEnum: Record<ApyFilterEnum, string> = {
  [ApyFilterEnum.ALL]: "All",
  [ApyFilterEnum.P5]: ">5%",
  [ApyFilterEnum.P10]: ">10%",
  [ApyFilterEnum.P25]: ">25%",
  [ApyFilterEnum.P50]: ">50%",
  [ApyFilterEnum.P100]: ">100%",
  [ApyFilterEnum.P500]: ">500%",
};

export const apyFilterOptions: IOption<ApyFilterEnum>[] = Object.values(
  ApyFilterEnum
).map((value) => ({
  label: labelByApyFilterEnum[value],
  value,
}));
